import { render, staticRenderFns } from "./BaseTraitChip.vue?vue&type=template&id=d96087ac&scoped=true&"
import script from "./BaseTraitChip.vue?vue&type=script&lang=js&"
export * from "./BaseTraitChip.vue?vue&type=script&lang=js&"
import style0 from "./BaseTraitChip.vue?vue&type=style&index=0&id=d96087ac&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96087ac",
  null
  
)

export default component.exports